/**
 * Extracts the OAuth error code (e.g. 'invalid_grant', 'missing_refresh_token',
 * 'login_required', 'timeout') from errors thrown by auth0-spa-js.
 */
export function getAuthErrorCode(error: unknown): string | undefined {
  if (typeof error === 'object' && error !== null && 'error' in error && typeof error.error === 'string') {
    return error.error;
  }
  return undefined;
}
